import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { CalendarMonth, GetApp } from "@mui/icons-material";
import { IconButton, Stack } from "@mui/material";
import * as XLSX from "xlsx/xlsx.mjs";
import { findKeyByValue, groupBy, sortArray } from "config/functions";
import { DATE_TIME_FORMAT, METER_TYPE } from "config/const";
import moment from "moment";


const Header = ({ list, setDatesReports }) => {
  const { bt } = useBizTypeTranslation();

  const exportToExcel = (list) => {
    if (list?.length > 0) {
      const wb = XLSX.utils.book_new();
  
      wb.Workbook = { Views: [{ RTL: true }] };
  
      const xlsxHeaders = ["מספר מונה", "שם מונה", "קריאה נוכחית", "קריאה קודמת", "צריכה בפועל", "תאריך", "עובד"];
      const xlsxHeadersElectric = ["מספר מונה", "שם מונה", "שפל", "גבע", "פסגה", "קריאה נוכחית", "קריאה קודמת", "צריכה בפועל", "תאריך", "עובד"];
  
      const listByType = groupBy(list, "meter.type");
  
      Object.keys(listByType).forEach((key) => {
        let items = listByType[key];
  
        items = items.sort((a, b) => {
          if (a.meter?._id !== b.meter?._id) {
            return a.meter?._id.localeCompare(b.meter?._id);
          }
          return new Date(a.created) - new Date(b.created);
        });
  
        let sheetData = [];
        const meterType = items[0]?.meter?.type;
        const isElectric = meterType === METER_TYPE.ELECTRICITY;
  
        sheetData.push(isElectric ? xlsxHeadersElectric : xlsxHeaders);
  
        let prevReading = {}; 
  
        items.forEach((item, index) => {
          const meterId = item?.meter?._id;
          const prevValue = prevReading[meterId] || ""; 
          const currValue = item?.readValue || 0; 
          const actualUsage = prevValue === "" ? "" : currValue - prevValue; 

          if(index === 0)
            sheetData.push([""]); 
          const row = isElectric
            ? [
                item?.meter?.guid || "",
                item?.meter?.name || "",
                item?.offPeakValue || "",
                item?.midPeakValue || "",
                item?.onPeakValue || "",
                currValue,
                prevValue,
                actualUsage,
                item?.created ? moment(item?.created).format(DATE_TIME_FORMAT) : "",
                item?.employeeName || "",
              ]
            : [
              item?.meter?.guid || "",
              item?.meter?.name || "",
                currValue,
                prevValue,
                actualUsage,
                item?.created ? moment(item?.created).format(DATE_TIME_FORMAT) : "",
                item?.employeeName || "",
              ];
  
          sheetData.push(row);
  
          prevReading[meterId] = currValue;
  
          if (index < items.length - 1 && meterId !== items[index + 1].meter?._id) {
            sheetData.push([""]); 
          }
        });
  
        const ws = XLSX.utils.aoa_to_sheet(sheetData);

        // ws['B3'].s = { 
        //   font: { bold: true, color: { rgb: "FFFFFF" }, sz: 14 },  // בולד, צבע לבן, גודל 14
        //   fill: { fgColor: { rgb: "4F81BD" } },  // צבע רקע כחול
        //   alignment: { horizontal: 'center', vertical: 'center' }  // יישור
        // };

        isElectric
          ? ws["!cols"] = [
            { wch: 5 }, 
            { wch: 10 },
            { wch: 10 },
            { wch: 10 },
            { wch: 10 },
            { wch: 10 },
            { wch: 10 },
            { wch: 10 },
            { wch: 14 },
            { wch: 20 },
          ]
          : ws["!cols"] = [
            { wch: 5 }, 
            { wch: 10 },
            { wch: 10 },
            { wch: 10 },
            { wch: 10 },
            { wch: 14 },
            { wch: 20 },
          ];

        ws["!rtl"] = true;
  
        XLSX.utils.book_append_sheet(wb, ws, `${bt(findKeyByValue(METER_TYPE, meterType))}`); // הוספת גיליון לטאב
      });
  
      XLSX.writeFile(wb, "דוח קריאות.xlsx");
    }
  };

  return (
    <Stack width="55%" direction="row" justifyContent="end">
      <IconButton onClick={() => setDatesReports(true)}>
        <CalendarMonth />
      </IconButton>
      <IconButton disabled={list?.length === 0} onClick={() => exportToExcel(list)}>
        <GetApp />
      </IconButton>
    </Stack>
  );
};
export default Header;
